import React, { useEffect, useState } from "react";
import { BiSolidHappyAlt } from "react-icons/bi";

const MemberLogin = () => {
  const [loginUser, setLoginUser] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  return (
    <div className="w-full h-[2000px]">
      <h1 className=" text-4xl text-black font-bold pt-40 items-center justify-center flex">
        Login here
      </h1>
      {console.log(loginUser)}
      <div className=" py-10 justify-center items-center grid ">
        <div>
          <label htmlFor="">
            {" "}
            UserName
            <input
              type="text"
              name="username"
              placeholder="  username"
              onChange={(e) => setLoginUser(e.target.value)}
            />
          </label>
        </div>

        <div>
          <label htmlFor="">
            Password
            <input
              type="password"
              name="password"
              placeholder="    password"
              onChange={(e) => setLoginPassword(e.target.value)}
            />
          </label>
        </div>
      </div>
      <button
        className=" py-5 px-5 text-white border-2  hover:bg-blue-700 hover:border-blue-600   mx-auto flex items-center opacity-75 hover:opacity-100"
        type="submit"
      >
        Login
      </button>
    </div>
  );
};

export default MemberLogin;
